import { Clipboard } from "@capacitor/clipboard"
import { detectPlatform } from "./detect"

/**
 * Кроссплатформенное копирование строки в буфер обмена:
 * - Android/iOS (Capacitor): @capacitor/clipboard
 * - Telegram / Browser: navigator.clipboard с fallback на legacy execCommand
 *
 * @returns true если копирование удалось
 */
export async function copyToClipboard(text: string): Promise<boolean> {
	const platform = detectPlatform()

	if (platform === "android" || platform === "ios") {
		try {
			await Clipboard.write({ string: text })
			return true
		} catch {
			return false
		}
	}

	if (
		typeof navigator !== "undefined" &&
		navigator.clipboard &&
		window.isSecureContext
	) {
		try {
			await navigator.clipboard.writeText(text)
			return true
		} catch {
			// fall through to legacy
		}
	}

	return legacyCopy(text)
}

export async function readFromClipboard(): Promise<string | null> {
	const platform = detectPlatform()
	if (platform !== "android" && platform !== "ios") return null

	try {
		const { value, type } = await Clipboard.read()
		if (type !== "text/plain") return null
		return value
	} catch {
		return null
	}
}

export function clearClipboard(): Promise<boolean> {
	return copyToClipboard("")
}

function legacyCopy(text: string): boolean {
	if (typeof document === "undefined") return false
	const textarea = document.createElement("textarea")
	textarea.value = text
	textarea.setAttribute("readonly", "")
	textarea.style.position = "fixed"
	textarea.style.opacity = "0"
	textarea.style.pointerEvents = "none"
	document.body.appendChild(textarea)
	textarea.select()
	try {
		return document.execCommand("copy")
	} catch {
		return false
	} finally {
		document.body.removeChild(textarea)
	}
}
